import { TokenRediApi } from 'src/app/interfaces/tokenDecode';
import { LogInResolve } from './../../interfaces/logIn';
import { Injectable, OnDestroy } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import * as urls from "../utility/urls";
import { environment } from "src/environments/environment";
import jwtDecode from "jwt-decode";
import { Observable, BehaviorSubject } from "rxjs";
import { CookieService } from "ngx-cookie-service";
import * as moment from "moment";
// import { SnackService } from "../snacks.service";

@Injectable()
export class RedIApiService implements OnDestroy {
  tokenName = "tokenRedIApi";
  tokenRefresh = "refreshRedIApi";
  refreshName = "refreshExpiration";
  expirationRefresh = 6;
  isLoggedInStorage = false;
  private isLoggedIn: BehaviorSubject<boolean>;
  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    // private snackService: SnackService
  ) {
    this.isLoggedIn = new BehaviorSubject(
      this.isLoggedInAll()
    ) as BehaviorSubject<boolean>;
    this.start();
  }
  ngOnDestroy() {
    this.stop();
  }

  private start(): void {
    window.addEventListener("storage", this.storageEventListener.bind(this));
  }

  private storageEventListener(event: StorageEvent) {
    if (event.key == this.tokenName) {
      this.isLoggedIn.next(!this.isLoggedInStorage);
      this.isLoggedInStorage = this.isLoggedInAll();
      this.isLoggedIn.next(this.isLoggedInStorage);
    }
  }

  private stop(): void {
    window.removeEventListener("storage", this.storageEventListener.bind(this));
    this.isLoggedIn.complete();
  }

  getIsLoggedIn() {
    return this.isLoggedIn.asObservable();
  }

  getSessionHeaders() {
    const headers = {
      Accept: "application/json",
      Authorization: "Bearer " + this.getToken(),
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    };
    return headers;
  }
  private getRefreshHeaders() {
    const headersRefresh: any = {
      Accept: "application/json",
      Authorization: this.getTokenRefresh(),
    };
    return headersRefresh;
  }
  private getJsonHeader() {
    const headers = {
      Accept: "application/json",
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
    };
    return headers;
  }
  deleteCookies() {
    this.cookieService.deleteAll();
    this.cookieService.delete("CAKEPHP", "/v1/");
  }
  private setCookieSession(cookie: string) {
    this.deleteCookies();
    this.cookieService.set("User", cookie, 0, "/", undefined, true, "Lax");
  }
  setCookieFlash() {
    const mensaje = { mensaje: "Tomado", estado: true };
    this.cookieService.set(
      "cake_flash",
      JSON.stringify(mensaje),
      0,
      "/v1/",
      undefined,
      true,
      "None"
    );
  }

  private setLocalValues(token: string, refresh: string) {
    localStorage.setItem(this.tokenRefresh, refresh);
    localStorage.setItem(this.tokenName, token);
    const date = moment();
    date.add(this.expirationRefresh, "hours");
    localStorage.setItem(this.refreshName, date.valueOf().toString());
  }
  initRefresh() {
    const headers = this.getRefreshHeaders();
    return new Promise<LogInResolve>((resolve) => {
      this.http
        .post<any>(
          environment.rediApi + urls.getToken + "refrescar",
          {},
          { headers }
        )
        .subscribe(
          (data) => {
            this.setCookieSession(data.cookie);
            this.setLocalValues(data.token, data.refresh_token);
            resolve({ estado: true, resultado: data.mensaje });
          },
          (error) => {
            this.logOut();
            resolve(this.initToken());
          }
        );
    });
  }
  private initToken() {
    return this.login(environment.rediApiUser, environment.rediApiPass);
  }

  getRoles(): Observable<any> {
    return this.http.get<any>(environment.rediApi + urls.getRoles);
  }
  changeRol(rol: string): Observable<any> {
    return this.http.get<any>(
      environment.rediApi + urls.cambiarRol + "?rol=" + rol
    );
  }
  login(email: string, password: string) {
    const headers = this.getJsonHeader();
    return new Promise<LogInResolve>((resolve) => {
      this.http
        .post<any>(
          environment.rediApi + urls.getToken + "obtener",
          {
            email,
            password,
          },
          { headers }
        )
        .subscribe(
          async (data) => {
            this.setCookieSession(data.cookie);
            this.setLocalValues(data.token, data.refresh_token);
            const tipo = this.decodeUserTipo();
            if (tipo) {
              this.isLoggedInStorage = true;
              this.isLoggedIn.next(this.isLoggedInStorage);
            }
            // this.rediRectLogin(tipo);
            resolve({ estado: true, resultado: data.mensaje });
          },
          (error) => {
            resolve({ estado: false, resultado: error?.error?.mensaje });
          }
        );
    });
  }

  
  private returnPacienteApp() {
    const key = localStorage.getItem("__pp_redi/_ionickv/usuario");
    if (key) {
      return true;
    } else {
      return false;
    }
  }

 
  /**Decodifica el JWT*/
  private getDecodeToken() {
    let token = {} as TokenRediApi;
    try {
      token = jwtDecode(this.getToken());
    } catch (error) {
      return token;
    }
    return token;
  }
  private getTokenExpiration() {
    try {
      return this.getDecodeToken().exp * 1000;
    } catch (error) {}
    return null;
  }
  decodeUserTipo() {
    const rol = this.getDecodeToken().usuario?.rol;
    if (!rol) {
      return "";
    }
    return rol;
  }
  decodeUserId() {
    let id = null;
    try {
      id = this.getDecodeToken().usuario?.id;
    } catch (error) {}
    return id;
  }
  decodeUserNombre() {
    const nombre = this.getDecodeToken().usuario?.nombre;
    if (!nombre) {
      return "";
    }
    return nombre;
  }
  decodeUserApellido() {
    const apellido = this.getDecodeToken().usuario?.apellido;
    if (!apellido) {
      return "";
    }
    return apellido;
  }
  private getTokenRefresh() {
    return localStorage.getItem(this.tokenRefresh);
  }
  private getRefreshExpiration() {
    const local = localStorage.getItem(this.refreshName);
    if (local) {
      return moment(new Date(local));
    } else {
      return null;
    }
  }
  /**Chequea estado de token y Refresh Token. Si alguno está expirado lo renueva */
  async checkEstatus(): Promise<any> {
    const tokenExp = this.isExpiredToken();
    const refreshExp = this.isExpiredRefresh();
    if (!refreshExp && tokenExp) {
      return (await this.initRefresh()).estado;
    } else {
      if (refreshExp) {
        return (await this.initToken()).estado;
      }
    }
    return true;
  }
  private isExpiredToken() {
    const date = moment();
    let returnValue;
    try {
      const expiration = moment(this.getTokenExpiration());
      returnValue = date >= expiration;
    } catch (error) {}
    if (returnValue !== false) {
      returnValue = true;
    }
    return returnValue;
  }
  private isExpiredRefresh() {
    const date = moment();
    const refreshExp = this.getRefreshExpiration();
    if (refreshExp) {
      return date >= refreshExp;
    } else {
      return true;
    }
  }

  private getToken() {
    let token = localStorage.getItem(this.tokenName);
    if (!token) {
      token = "";
    }
    return token;
  }

  logOut() {
    this.deleteCookies();
    localStorage.clear();
    this.isLoggedInStorage = false;
    const url = new URL(environment.logOut);
    url.searchParams.append("returnUrl", window.location.pathname);
    this.isLoggedIn.next(this.isLoggedInStorage);
    window.location.href = url.toString();
  }
  isLoggedInPaciente() {
    const userTipo = this.decodeUserTipo();
    const refresh = this.isExpiredRefresh();
    if (userTipo === "patient" && !refresh) {
      return true;
    }
    return false;
  }
  isLoggedInAll() {
    const userTipo = this.decodeUserTipo();
    const refresh = this.isExpiredRefresh();
    if (userTipo && !refresh) {
      return true;
    }
    return false;
  }

}
